import React from "react";
import Modal from './Modal';

// Shown once, on the sentence that crosses the daily goal.
//
// Three jobs, in order of what actually brings someone back:
//
//   1. Mark the finish. Sessions that end in fatigue teach fatigue; sessions
//      that end in a clear "done" are the ones that repeat.
//   2. Name the reward. The streak is the real one — it's the thing that grows
//      and that stopping would cost.
//   3. Give a concrete reason to return. "See you tomorrow" is a weak hook;
//      "3 sentences come up for review tomorrow" is a debt, and debts pull
//      harder than invitations.
//
// Dismissible, and explicitly so: hitting the goal is permission to stop, not
// an instruction to.
export default class DailyGoalModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { reminderSaved: false, savingReminder: false };
  }

  // Asking for the reminder here rather than at sign-up or after the first
  // sentence: this is the one moment they've just felt the product work, so
  // "shall I remind you tomorrow?" reads as continuing something rather than
  // interrupting it. It's also the only external trigger a new player has —
  // their review queue is empty, so there's nothing else to bring them back.
  //
  // The hour is now, because now is evidently a time they play.
  setReminder() {
    const { updateDailyReminderPath } = this.props;
    if(!updateDailyReminderPath) {
      return;
    }

    this.setState({ savingReminder: true });

    $.ajax({
      headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
      url: updateDailyReminderPath,
      method: 'post',
      data: { reminder_at: new Date().getHours() }
    })
      .done(() => this.setState({ reminderSaved: true }))
      .fail(() => alert("Sorry, we couldn't set that reminder. You can set one from your dashboard."))
      .always(() => this.setState({ savingReminder: false }));
  }

  renderReminderOffer() {
    const { summary, updateDailyReminderPath } = this.props;

    // Nothing to offer if they already have one set, or if the host didn't pass
    // a path (the demo).
    if(!updateDailyReminderPath || !summary || summary.reminderAt != null) {
      return null;
    }

    if(this.state.reminderSaved) {
      return (
        <p className="mb-0 mt-3">
          <i className="fa fa-check mr-1" aria-hidden="true"></i>
          We'll email you a reminder around this time tomorrow.
        </p>
      );
    }

    return (
      <p className="mb-0 mt-3">
        <button
          type="button"
          className="btn btn-outline-primary"
          disabled={this.state.savingReminder}
          onClick={() => this.setReminder()}
        >
          {this.state.savingReminder ? 'Setting…' : 'Remind me tomorrow'}
        </button>
      </p>
    );
  }

  renderStreak() {
    const streak = this.props.summary && this.props.summary.streak;
    if(!streak || streak < 2) {
      return null;
    }
    return (
      <p className="mb-2">
        That's <strong>{streak} days in a row</strong>.
      </p>
    );
  }

  renderTomorrow() {
    const dueTomorrow = this.props.summary && this.props.summary.dueTomorrow;
    if(!dueTomorrow) {
      return (
        <p className="text-muted mb-0">
          Come back tomorrow to keep it going.
        </p>
      );
    }
    return (
      <p className="text-muted mb-0">
        <strong>{dueTomorrow}</strong> {dueTomorrow === 1 ? 'sentence comes' : 'sentences come'} up
        for review tomorrow.
      </p>
    );
  }

  render() {
    const { goal, wordsPlayedToday } = this.props;

    const footer = (
      <>
        <button type="button" className="btn btn-link" onClick={() => this.modal && this.modal.hide()}>
          Keep playing
        </button>
        <a href="/" className="btn btn-primary">Done for today</a>
      </>
    );

    return (
      <Modal
        ref={(el) => this.modal = el}
        title="Daily goal complete"
        footer={footer}
        onHidden={this.props.onHidden}
      >
        <div className="text-center">
          <p className="display-4 mb-2">&#x1F389;</p>
          {/* "from scratch" rather than "50 of 50". This is the one moment the
              player has just done the thing the product exists for, and a
              counter reports arithmetic at them instead of naming it. */}
          <h4 className="mb-3">
            That's {wordsPlayedToday} words
            {this.props.languageEnglishName ? ` of ${this.props.languageEnglishName}` : ''}
            {' '}you wrote from scratch.
          </h4>
          {this.renderStreak()}
          {this.renderTomorrow()}
          {this.renderReminderOffer()}
        </div>
      </Modal>
    );
  }
}
